import {IStructureItem, StructureName} from "../client-site";

export const ALLOW_TO_SCHEDULE_DEFAULT = 14;
export const APPOINTMENT_STEP_GAP = 15;
export const ALLOW_TO_ENTER_WAITING_LIST_MIN = 1;
export const ALLOW_TO_ENTER_WAITING_LIST_MAX = 10;

export const BASIC_TEMPLATE_LEAD_COLOR_DEFAULT = "#F9DBDB";
export const BASIC_TEMPLATE_CTA_COLOR_DEFAULT = "#D91414";
export const DEFAULT_TEMPLATE = 'professional';
export const CUSTOMER_MARKER_COLOR_DEFAULT = 'white';
export const CUSTOMER_MARKER_COLORS: Array<{ key: string; value: string }> = [
  { key: 'white', value: '#FFFFFF' },
  { key: 'red', value: '#EF4444' },
  { key: 'orange', value: '#F97316' },
  { key: 'yellow', value: '#EAB308' },
  { key: 'green', value: '#22C55E' },
  { key: 'teal', value: '#14B8A6' },
  { key: 'blue', value: '#3B82F6' },
  { key: 'purple', value: '#A855F7' },
  { key: 'pink', value: '#EC4899' },
];

export const DEFAULT_STRUCTURE: Array<IStructureItem> = [
  {name: StructureName.DESCRIPTION, visible: true },
  {name: StructureName.SERVICES, visible: true },
  {name: StructureName.SOCIALS, visible: true },
  {name: StructureName.WORKING_HOURS, visible: true },
  {name: StructureName.LOCATION, visible: true },
  // {name: StructureName.GALLERY, visible: false },
]
